import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';

interface DeleteSkillDialogProps {
    open: boolean;
    skillName: string;
    onClose: () => void;
    onConfirm: () => void;
    loading: boolean;
}

export default function DeleteSkillDialog({
    open,
    skillName,
    onClose,
    onConfirm,
    loading,
}: DeleteSkillDialogProps) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>Удалить навык</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Удалить навык <strong>{skillName}</strong>?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>
                    Отмена
                </Button>
                <Button onClick={onConfirm} color="error" variant="contained" disabled={loading}>
                    {loading ? 'Удаление...' : 'Удалить'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
